export const replaceSpecialChars = (value: string) => {
  return value.replace(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/, '');
};
